import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const SearchIcon = withSvgIcon(
    <g>
        <path d="M272.4 50.8c-61.1-61.1-160.5-61.1-221.6 0-61.1 61.1-61.1 160.5 0 221.6 57.2 57.2 148 60.8 209.4 10.9L309 332l-7.4 7.4L457.1 495l37.9-37.9-155.5-155.5-7.5 7.4-48.7-48.7c49.9-61.5 46.3-152.3-10.9-209.5zM70.6 252.6c-50.2-50.2-50.2-131.9 0-182 50.2-50.2 131.8-50.2 182 0 50.2 50.2 50.2 131.8 0 182-50.2 50.2-131.8 50.2-182 0z" />
    </g>
);
